import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CharityCard from '../Cards/charityCard';
import style from './CharityList.module.scss';
import ReactModal from 'react-modal';
import ModalPageContent from '../ModalPageContent';
const CharityList = props => {
    const { charities } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [routePath, setRoutePath] = useState(true);
    // const filterNames = filters?.map(type =>
    //     type.value.map(value => [type.type, value.value].join('-')).join(' ')
    //   )
    //   .join(' ');

    const handleOpenCharity = (routePath) => {
        setRoutePath(routePath);
        if (routePath) {
            setIsOpen(true);
        }
    }
    return (
        <>
            <div className={style.content}>
                <div className={style.items}>
                    {charities.data.map((item, id) => (
                        <div className={style.card} key={id}>
                            <CharityCard {...item} handleOpen={handleOpenCharity} />
                        </div>
                    ))}
                </div>
            </div>
            <ReactModal
                isOpen={isOpen}
                onRequestClose={() => {
                    setIsOpen(false);
                    setRoutePath(null);
                }}
                className='page-modal charity-modal'
                overlayClassName='page-modal-overlay'
                contentLabel='Modal'
                closeTimeoutMS={800}
            >
                <button type='button' className='close-btn' onClick={() => {
                    setIsOpen(false);
                    setRoutePath(null);
                }}>
                    <span />
                    <span />
                </button>
                <ModalPageContent key={routePath} pagePath={routePath} />
            </ReactModal>
        </>
    );
};

CharityList.propTypes = {
    charities: PropTypes.object,
};

export default CharityList;
